export default ({ request }) => ({
  listResearchDictionaryApi (data) {
    return request({
      url: '/digitalCenter/researchDictionary/list',
      method: 'post',
      data
    })
  },
  saveResearchDictionaryApi (data) {
    return request({
      url: '/digitalCenter/researchDictionary/save',
      method: 'post',
      data
    })
  },
  detailResearchDictionaryApi (data) {
    return request({
      url: '/digitalCenter/researchDictionary/detail',
      method: 'post',
      data
    })
  },
  delResearchDictionaryApi (data) {
    return request({
      url: '/digitalCenter/researchDictionary/del',
      method: 'post',
      data
    })
  }
})
